import { EngagementBuyer } from '../slices/marketplace/timeline/models/engagement-buyer.model';
import { MarketplaceOpportunityStatus } from '../slices/marketplace/opportunity/models/opportunity-status';

/**
 * A buyer who is still in the deal from the seller's side: active and not out on a Lost
 * Opportunity. With per-buyer timelines a missed Expression of Interest is written on the
 * buyer's own timeline action and isActive stays true, so the status is read from any action
 * state. Mirrors EngagementBuyer.IsSelectableBySeller — keep the two in sync.
 */
export const isSelectableBuyer = (buyer: EngagementBuyer): boolean =>
    buyer.isActive &&
    !buyer.actionState?.some(
        (state) =>
            state.buyerStatus === MarketplaceOpportunityStatus.LostOpportunity
    );
